import authority from './../../system/authorityManage/authority.vue';
import dataAuthority from './dataAuthority.vue';
export default {
  components: {
    authority,
    dataAuthority
  },
  data() {
    return {
      activeKey: 1
    };
  },
  methods: {
    handleOk() {
      this.activeKey = 2;
    }
  }
};